export default function (http) {
    return {
        query (data){
            return http.json({
                url: '/bill/item/query',
                data
            });
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/billItem.js